<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-sequence1-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-sequence1-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.67901763395895;"
    data-aspect-ratio="0.679"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-sequence1-xs-img"
      class="g-sequence1-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/sequence1-xs.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai0-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:3.4032%;margin-top:-8.5px;left:90.4036%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle0">00:00</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:10.5106%;margin-top:-9.1px;left:52.6986%;margin-left:-42.5px;width:85px;"
    >
      <p class="g-pstyle1">Good&rsquo;s car</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:40.4285%;margin-top:-17.5px;left:48.0587%;margin-left:-116px;width:232px;"
    >
      <p class="g-pstyle2">Good's car partly blocks the street.</p>
      <p class="g-pstyle2">Another car passes by.</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:54.2267%;margin-top:-8.5px;left:90.633%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle0">00:04</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:62.3628%;margin-top:-9.1px;left:23.8235%;margin-left:-32px;width:64px;"
    >
      <p class="g-pstyle1">ICE car</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:62.3628%;margin-top:-9.1px;right:32.4904%;width:85px;"
    >
      <p class="g-pstyle3">Good&rsquo;s car</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:90.7581%;margin-top:-9.1px;left:48.0051%;margin-left:-71.5px;width:143px;"
    >
      <p class="g-pstyle2">ICE vehicle pulls up.</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-sequence1-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 1.04939088884565;"
    data-aspect-ratio="1.049"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-sequence1-sm-img"
      class="g-sequence1-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/sequence1-sm.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai1-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:3.4032%;margin-top:-8.5px;left:85.6464%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle0">00:00</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:10.5106%;margin-top:-9.1px;left:61.2488%;margin-left:-42.5px;width:85px;"
    >
      <p class="g-pstyle1">Good&rsquo;s car</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:40.4285%;margin-top:-17.5px;left:50.9919%;margin-left:-116px;width:232px;"
    >
      <p class="g-pstyle2">Good's car partly blocks the street.</p>
      <p class="g-pstyle2">Another car passes by.</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:54.2267%;margin-top:-8.5px;left:85.7948%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle0">00:04</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:62.3628%;margin-top:-9.1px;left:42.4671%;margin-left:-32px;width:64px;"
    >
      <p class="g-pstyle1">ICE car</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:62.3628%;margin-top:-9.1px;right:29.1674%;width:85px;"
    >
      <p class="g-pstyle3">Good&rsquo;s car</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:90.7581%;margin-top:-9.1px;left:50.957%;margin-left:-71.5px;width:143px;"
    >
      <p class="g-pstyle2">ICE vehicle pulls up.</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-sequence1-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 1.35606149024534;"
    data-aspect-ratio="1.356"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-sequence1-md-img"
      class="g-sequence1-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/sequence1-md.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai2-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:3.2099%;margin-top:-9.6px;left:78.2033%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">00:00</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:10.3069%;margin-top:-10.2px;left:59.3751%;margin-left:-47px;width:94px;"
    >
      <p class="g-pstyle1">Good&rsquo;s car</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:40.4279%;margin-top:-19.8px;left:50.4753%;margin-left:-131px;width:262px;"
    >
      <p class="g-pstyle2">Good's car partly blocks the street.</p>
      <p class="g-pstyle2">Another car passes by.</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:53.9594%;margin-top:-9.6px;left:78.3233%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">00:04</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:62.0838%;margin-top:-10.2px;left:44.8649%;margin-left:-35px;width:70px;"
    >
      <p class="g-pstyle1">ICE car</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:62.0838%;margin-top:-10.2px;right:33.2235%;width:94px;"
    >
      <p class="g-pstyle3">Good&rsquo;s car</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:90.4378%;margin-top:-10.2px;left:48.4449%;margin-left:-80px;width:160px;"
    >
      <p class="g-pstyle2">ICE vehicle pulls up.</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-sequence1-lg"
    class="g-artboard"
    style="min-width: 930px;aspect-ratio: 3.875;"
    data-aspect-ratio="3.875"
    data-min-width="930"
  >
    <div
      id="g-sequence1-lg-img"
      class="g-sequence1-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/sequence1-lg.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai3-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:6.5094%;margin-top:-9.6px;left:44.4281%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">00:00</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:6.5094%;margin-top:-9.6px;left:95.0423%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">00:04</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:22.1517%;margin-top:-10.2px;left:31.0662%;margin-left:-47px;width:94px;"
    >
      <p class="g-pstyle1">Good&rsquo;s car</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:22.985%;margin-top:-10.2px;left:71.2977%;margin-left:-35px;width:70px;"
    >
      <p class="g-pstyle1">ICE car</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:22.985%;margin-top:-10.2px;right:13.1522%;width:94px;"
    >
      <p class="g-pstyle2">Good&rsquo;s car</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:84.485%;margin-top:-19.8px;left:24.7502%;margin-left:-131px;width:262px;"
    >
      <p class="g-pstyle3">Good's car partly blocks the street.</p>
      <p class="g-pstyle3">Another car passes by.</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:80.4849%;margin-top:-10.2px;left:73.8384%;margin-left:-80px;width:160px;"
    >
      <p class="g-pstyle3">ICE vehicle pulls up.</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-01-08 16:06 -->

<!-- Generated by ai2svelte v0.123.1 - 2026-01-08 16:06 -->
<!-- ai file: sequence1.ai -->
<style lang="scss">
  #g-sequence1-box {
    container-type: inline-size;
    container-name: g-sequence1-box;
  }
  #g-sequence1-box,
  #g-sequence1-box .g-artboard {
    margin: 0 auto;
  }
  #g-sequence1-box p {
    margin: 0;
  }
  #g-sequence1-box .g-aiAbs {
    position: absolute;
  }
  #g-sequence1-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-sequence1-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-sequence1-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-sequence1-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-sequence1-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-sequence1-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-sequence1-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-sequence1-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-sequence1-lg {
        display: block !important;
      }
    }
  }
  #g-sequence1-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-sequence1-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-sequence1-xs .g-pstyle0 {
    font-weight: 500;
    line-height: 16px;
    height: 16px;
    font-size: 13px;
    text-align: center;
  }
  #g-sequence1-xs .g-pstyle1 {
    font-weight: 700;
    height: 17px;
    text-align: center;
    color: rgb(255, 212, 48);
  }
  #g-sequence1-xs .g-pstyle2 {
    font-weight: 700;
    height: 17px;
    text-align: center;
  }
  #g-sequence1-xs .g-pstyle3 {
    font-weight: 700;
    height: 17px;
    text-align: right;
    color: rgb(255, 212, 48);
  }
  #g-sequence1-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-sequence1-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-sequence1-sm .g-pstyle0 {
    font-weight: 500;
    line-height: 16px;
    height: 16px;
    font-size: 13px;
    text-align: center;
  }
  #g-sequence1-sm .g-pstyle1 {
    font-weight: 700;
    height: 17px;
    text-align: center;
    color: rgb(255, 212, 48);
  }
  #g-sequence1-sm .g-pstyle2 {
    font-weight: 700;
    height: 17px;
    text-align: center;
  }
  #g-sequence1-sm .g-pstyle3 {
    font-weight: 700;
    height: 17px;
    text-align: right;
    color: rgb(255, 212, 48);
  }
  #g-sequence1-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-sequence1-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 19px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-sequence1-md .g-pstyle0 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    font-size: 15px;
    text-align: center;
  }
  #g-sequence1-md .g-pstyle1 {
    font-weight: 700;
    height: 19px;
    text-align: center;
    color: rgb(255, 212, 48);
  }
  #g-sequence1-md .g-pstyle2 {
    font-weight: 700;
    height: 19px;
    text-align: center;
  }
  #g-sequence1-md .g-pstyle3 {
    font-weight: 700;
    height: 19px;
    text-align: right;
    color: rgb(255, 212, 48);
  }
  #g-sequence1-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-sequence1-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 19px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-sequence1-lg .g-pstyle0 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    font-size: 15px;
    text-align: center;
  }
  #g-sequence1-lg .g-pstyle1 {
    font-weight: 700;
    height: 19px;
    text-align: center;
    color: rgb(255, 212, 48);
  }
  #g-sequence1-lg .g-pstyle2 {
    font-weight: 700;
    height: 19px;
    text-align: right;
    color: rgb(255, 212, 48);
  }
  #g-sequence1-lg .g-pstyle3 {
    font-weight: 700;
    height: 19px;
    text-align: center;
  }

  /* Custom CSS */
  @mixin shadow-roquefort($clr) {
    text-shadow:
      0 0 2px rgba($clr, 1),
      0 0 2px rgba($clr, 0.8),
      0 0 2px rgba($clr, 0.5);
  }
  .g-boxtext {
    background-color: rgba(34, 34, 34, 0.768627451);
    border-radius: 2px;
    padding: 10px 9px;
  }
  .g-timestamp {
    background-color: rgba(34, 34, 34);
    padding: 1px 3px;
  }
  .g-yellowtext {
    @include shadow-roquefort(#000000);
  }
</style>
